// extracted by mini-css-extract-plugin
export var button = "_lx-0";
export var donut = "_lx-1";
export var donutFill = "_lx-3";
export var donutTrack = "_lx-2";